import { DataFlowColumn } from '../dataset/dataflowcolumn';
import { IValidationContext, UniqueCaseSensitiveValidator } from 'shell-models-lib';
import { sanitizeAndFormatString } from 'app/shared/utils/string.util';
import { IViolation } from '../base/annotation';
import { IExtraFieldInfo } from 'app/interfaces/IExtraFieldInfo';
import { Transformation } from './transformation';
import { Metamodel } from '../base/model';

export interface IKeyColumnTransformation {
    newColumn: boolean;
    keyColumn: DataFlowColumn;
}

export function validateColumn(keyColumnTransformation: Transformation, value?: DataFlowColumn, violation?: IViolation, context?: IValidationContext): IViolation[] | undefined {
        const violations: IViolation[] = [];

        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!(keyColumnTransformation as any).keyColumn.name) {
            violations.push({
                context: keyColumnTransformation,
                message: () => sanitizeAndFormatString(stringResources.DataFlowSurrogateKeyNoColumnNameError, keyColumnTransformation.name)
            });
        }
        if (keyColumnTransformation.outputColumns) {
            const uniqueValidatorViolations = UniqueCaseSensitiveValidator.INSTANCE.validate(
                {},
                Metamodel.modelOf(keyColumnTransformation).attribute('keyColumn'),
                keyColumnTransformation.outputColumns(), keyColumnTransformation, context);
            if (uniqueValidatorViolations) {
                violations.push({
                    context: keyColumnTransformation,
                    message: () => sanitizeAndFormatString(stringResources.DataFlowSurrogateKeyDuplicateColumnNameError, keyColumnTransformation.name)
                });
            }
        }
        return violations;
    }

export function keyTransformationOutputColumns(transformation: IKeyColumnTransformation, inputColumns: DataFlowColumn[]): DataFlowColumn[] {
    const columns: DataFlowColumn[] = [];
    let keyAdded: boolean;
    for (const column of inputColumns) {
        if (transformation.keyColumn && transformation.keyColumn.name !== column.name) {
            columns.push(column);
        } else if (transformation.keyColumn) {
            columns.push(transformation.keyColumn);
            keyAdded = true;
            transformation.newColumn = false;
        }
    }
    if (!keyAdded && transformation.keyColumn) {
        columns.push(transformation.keyColumn);
    }

    return columns;
}

export function getInspectSummaryOutputFields(transformation: IKeyColumnTransformation): IExtraFieldInfo[] {
    return [
        {
            name: () => stringResources.New,
            icon: () => 'svg-i-9x9-Update',
            value: () => transformation.newColumn ? 1 : 0
        },
        {
            name: () => stringResources.TransformationInspect_UpdatedColumns,
            icon: () => 'svg-i-9x9-Update',
            value: () => transformation.newColumn ? 0 : 1
        }
    ];
}

export function getInspectDetailsOutputFields(transformation: Transformation, fieldName: string = stringResources.Key): IExtraFieldInfo[] {
    return [
        {
            name: () => fieldName,
            icon: _isKey.bind(transformation, transformation)
        }
    ];
}

function _isKey(transforamtion: Transformation, column: DataFlowColumn): string {
    return transforamtion === column.owner ? 'svg-i-20x20-checkmark' : '';
}
